module.exports = __webpack_public_path__ + "static/img/store-icon5.6fc72f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/store-icon5.png
// module id = /8l+
// module chunks = 1